import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6abb9b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "px-10 pt-10"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "drafts-footer" }
const _hoisted_5 = { class: "drafts-footer__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListTitle = _resolveComponent("ListTitle")!
  const _component_ListNewItem = _resolveComponent("ListNewItem")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_EmptyPage = _resolveComponent("EmptyPage")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_list, {
      loading: _ctx.state.loading,
      "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.loading) = $event)),
      finished: _ctx.state.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.goOnLoad
    }, {
      default: _withCtx(() => [
        (_ctx.state.list.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_van_checkbox_group, {
                modelValue: _ctx.checked,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checked) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "list-item",
                      onClick: ($event: any) => (_ctx.toDetail(item))
                    }, [
                      _createVNode(_component_ListTitle, {
                        name: `${item.user_name || ''}${item.user_name ? '的' : ''}${item.name}`
                      }, null, 8, ["name"]),
                      _createVNode(_component_ListNewItem, {
                        label: "审批编号",
                        value: item.code
                      }, null, 8, ["value"]),
                      (item.desc)
                        ? (_openBlock(), _createBlock(_component_ListNewItem, {
                            key: 0,
                            label: "审批内容",
                            value: item.desc
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_ListNewItem, {
                          label: "保存时间",
                          value: item.update_date
                        }, null, 8, ["value"]),
                        (_ctx.isEdit)
                          ? (_openBlock(), _createBlock(_component_van_checkbox, {
                              key: 0,
                              name: item.id,
                              ref_for: true,
                              ref: el => (_ctx.checkboxRefs[_ctx.index] = el),
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, null, 8, ["name"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["list-item-status", _ctx.statusClass(item.state)])
                      }, _toDisplayString(item.state_name), 3)
                    ], 8, _hoisted_2))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : (_openBlock(), _createBlock(_component_EmptyPage, {
              key: 1,
              style: {"margin-top":"100px !important"},
              isHide: true
            }))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#F8542C",
                square: "",
                style: {"margin-right":"10px"},
                onClick: _ctx.deleteDrafts
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除草稿 ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#3d6eeb",
                square: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEdit = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 完成 ")
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createBlock(_component_van_button, {
              key: 1,
              class: "btn",
              block: "",
              color: "#3d6eeb",
              square: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isEdit = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 编辑 ")
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}